var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9118 1.09283C12.8104 0.714532 12.5678 0.398285 12.2286 0.202508C11.5286 -0.201715 10.63 0.0389304 10.2257 0.739224L10 1.13007L9.77431 0.739165C9.37003 0.0390477 8.47156 -0.201715 7.77138 0.202449H7.77132C7.07115 0.606731 6.83044 1.50521 7.23466 2.20544L8.30686 4.06257L4.35062 10.9151H1.46628C0.657771 10.9151 0 11.5728 0 12.3813C0 13.1898 0.657771 13.8476 1.46628 13.8476H12.6018L10.9086 10.9151H7.73683L12.7653 2.2055C12.9611 1.86632 13.0132 1.47113 12.9118 1.09283Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5337 10.9153H15.6493L12.3703 5.23584L10.6772 8.16839L15.7684 16.9865C15.9642 17.3257 16.2804 17.5683 16.6588 17.6697C16.7851 17.7036 16.9133 17.7204 17.0406 17.7204C17.2947 17.7204 17.5455 17.6537 17.7715 17.5232C18.4717 17.1189 18.7124 16.2204 18.3081 15.5203L17.3424 13.8478H18.5337C19.3422 13.8478 19.9999 13.19 19.9999 12.3815C19.9999 11.573 19.3422 10.9153 18.5337 10.9153Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.98037 15.0205L1.69198 15.52C1.28776 16.2202 1.52852 17.1187 2.2287 17.5229C2.45902 17.6559 2.71075 17.7191 2.95937 17.719C3.46647 17.719 3.96037 17.4561 4.23169 16.9862L5.36659 15.0205H1.98037Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.255209923a1fe53a5f07f573145857e1.svg";
export { ForwardRef as ReactComponent };